module.exports = __webpack_public_path__ + "img/c05_unitstartechscorpiochampion_Normal_ua.d599b001.webp";